import React, { useState, useEffect } from 'react'
import './style.scss'
import OTPInput from "react-otp-input";
// import {clearVerifyResponse, checkExistingUser, verifyOTP, clearSendOTP, postInvestDataETF} from "../action";
// import { postInvestDataETF } from '../../../landing/Product/actions';
import moment from "moment";
import ENV_CONFIG from '../../../../../config/environment';

const VerifyOtp = (props) => {
    const {onOtpSubmit, maskedEmail, maskedMobile, verifyOTP, resendOTP, secretLink, pan, dob, mobile, journey, registrationType, encrypt, decrypt} = props;

    const [OTP, setOTP] = useState("");
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(0);
    const [verifyOtpResponse, setVerifyOtpResponse] = useState(null);
    const [error, setError] = useState(null);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        document.querySelector('[aria-label$="Digit 1"]').focus();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
          if (seconds > 0) {
            setSeconds(seconds - 1);
          }
      
          if (seconds === 0) {
            if (minutes === 0) {
              clearInterval(interval);
            } else {
              setSeconds(59);
              setMinutes(minutes - 1);
            }
          }
        }, 1000);
      
        return () => {
          clearInterval(interval);
        };
    }, [seconds, minutes]);

    const handleChange = (OTP) => {
        setOTP(OTP);
    }

    const onSubmit = () => {
    if(journey === 'INVESTMENT_BASKET_JOURNEY')
    {
        const url =`${ENV_CONFIG.INVESTOR_BASE_URL}/invest-now?id=${verifyOtpResponse && verifyOtpResponse.data.uuid}`;
        window.open(url,'_blank');
    }
        onOtpSubmit(OTP);
    }

    const resendOtp = async () => {
        let data = {
            id: secretLink,
        }
        const response = await resendOTP(encrypt(JSON.stringify(data)));
        setMinutes(0);
        setSeconds(59);
    };

    useEffect(()=>{
        if(String(OTP).length === 6){
            let data = {
                otp: String(OTP),
                panNumber: pan && pan.toUpperCase(),
                dob: moment(dob).format("DD-MMM-YYYY"),
                secretLink: secretLink,
                registrationType: registrationType,
                journey: journey,
            }
            const verifyOtp = async() => {
                    const response = await verifyOTP(encrypt(JSON.stringify(data)));
                    if(response && response.status === false) {
                        setError(response.message);
                    }
                    else if(response) {
                        setVerifyOtpResponse(response);
                        setError(null);
                    }
                    else setError("Wrong OTP entered");
            }
            verifyOtp();
        }
    }, [OTP]);

    useEffect(() => {
        if(verifyOtpResponse) {
            if(verifyOtpResponse.status){
                setDisabled(false);
            }
            else setDisabled(true);
        }
    }, [verifyOtpResponse]);

    return(
        <div>
            <h3 className="title">Enter OTP</h3>
            {(maskedEmail && maskedMobile) ? <div className="info">
                Please enter OTP sent to registered email ID ({maskedEmail}) & Mobile number ({maskedMobile})
            </div> : maskedEmail ? <div className="info">
                Please enter OTP sent to registered email ID ({maskedEmail})
            </div> : maskedMobile ? <div className="info">
                Please enter OTP sent to registered Mobile number ({maskedMobile})
            </div> : ''}
            <div className="otp-field">
                <OTPInput
                    onChange={handleChange}
                    type="number"
                    value={OTP}
                    inputStyle="input-style"
                    numInputs={6}
                    separator={<span>-</span>}
                    placeholder="0"
                    containerStyle="otp-inputs"
                    shouldAutoFocus
                    isInputNum
                    isDisabled={!disabled}
                />
                <span className="otp-label">OTP</span>
            </div>
            {disabled && <div className="countdown-text">
                    <p>
                        <button
                            className="resend-otp"
                            disabled={seconds > 0 || minutes > 0}
                            onClick={resendOtp}
                        >
                            Resend OTP
                        </button> {(seconds > 0 || minutes > 0) && <span className="timer">
                            {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                        </span>}
                    </p>
            </div>}
            {!disabled && <p className="success-message">OTP verified successfully</p>}
            {error && <p className="error-message">{error}</p>}
            <button className="submit" onClick={onSubmit} disabled={String(OTP).length !== 6 || disabled}>Submit</button>
        </div>
    )
}

export default VerifyOtp;